/**
 * A list of z-indexes that we use in Caprica
 */
export const SIDEBAR_Z_INDEX = 22;

export const HEADER_Z_INDEX = SIDEBAR_Z_INDEX + 2;

export const DEFAULT_FLOATING_Z_INDEX = 1000;

// notifications and tooltips should be on top of everything
export const TOOLTIP_Z_INDEX = DEFAULT_FLOATING_Z_INDEX + 100;

export const NOTIFICATION_Z_INDEX = TOOLTIP_Z_INDEX + 100;
